'use client'
import { useIndustriesNavbarScroll } from '@/Hooks'
import Link from 'next/link'
import React, { useEffect } from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import FiFromStrategy from './components/FiFromStrategy'
import SeamlessFinTech from './components/SeamlessFinTech'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'
import EcommerceSectionThree from './components/EcommerceSectionThree'
import EcoWhyChoose from './components/EcoWhyChoose'

const FAQS = [
   {
      question:
         'What is the creation of eCommerce software, and why is it important for online companies?',
      answer: (
         <>
            Developing custom online stores, marketplaces, and digital commerce
            solutions that improve shopping experiences, expedite processes, and
            boost sales conversions is known as eCommerce software development. It
            guarantees safe transactions, recommendations powered by AI, and smooth
            third-party interfaces for company expansion.
         </>
      ),
   },
   {
      question: 'What are the key features of a custom eCommerce platform?',
      answer: (
         <>
            <p className="faq-list-title m-0">
               A custom-built eCommerce solution includes:
            </p>
            <ul className="faq-list">
               <li>AI-powered product recommendations</li>
               <li>Multi-channel selling & omnichannel support</li>
               <li>Real-time inventory and order tracking</li>
               <li>Secure payment gateway integration</li>
               <li>Seamless ERP & CRM integration</li>
            </ul>
         </>
      ),
   },
   {
      question: 'How can AI improve eCommerce platforms?',
      answer: (
         <>
            <p className="faq-list-title m-0">AI enhances eCommerce by:</p>
            <ul className="faq-list">
               <li>User behavior-based personalization of product recommendations</li>
               <li>Optimizing pricing strategies through predictive analytics</li>
               <li>Automating chatbots & virtual assistants for customer support</li>
               <li>Enhancing fraud detection with AI-powered security tools</li>
            </ul>
         </>
      ),
   },
   {
      question: 'Are multi-vendor markets like Etsy or Amazon something you develop?',
      answer: (
         <>
            True! With vendor management, automated commission monitoring, and
            real-time analytics, we create multi-seller marketplaces that are
            scalable and highly effective. Our solutions offer smooth user
            experiences and support business models that are B2B, B2C, and D2C.
         </>
      ),
   },
   {
      question: 'How do you provide payment security for eCommerce software?',
      answer: (
         <>
            We set up payment systems that follow PCI-DSS standards, add
            multi-factor authentication for extra security, and use AI to spot and
            stop fraud. It does not matter if someone pays with a card, crypto, or a
            wallet app. We just make sure it is secure, start to finish.
         </>
      ),
   },
   {
      question: 'What are the benefits of a Progressive Web App (PWA) for eCommerce?',
      answer: (
         <>
            <p className="faq-list-title m-0">PWAs offer:</p>
            <ul className="faq-list">
               <li>Faster page loading for better user experience</li>
               <li>Offline browsing for uninterrupted shopping</li>
               <li>Improved SEO rankings with mobile-first indexing</li>
               <li>App-like features without downloading an app</li>
            </ul>
         </>
      ),
   },
   {
      question: 'What industries benefit from custom eCommerce solutions?',
      answer: (
         <>
            <p className="faq-list-title m-0">Our eCommerce solutions cater to:</p>
            <ul className="faq-list">
               <li>Retail & fashion (D2C & B2C eCommerce stores)</li>
               <li>Electronics & digital products (secure digital goods selling)</li>
               <li>B2B & wholesale (bulk order processing & invoicing automation)</li>
               <li>
                  Subscription & membership-based businesses (recurring billing &
                  custom pricing models)
               </li>
            </ul>
         </>
      ),
   },
   {
      question: 'Are you able to integrate eCommerce platforms with ERP and CRM systems?',
      answer: (
         <>
            Indeed! In order to ensure effective backend procedures, we offer smooth
            ERP & CRM connections that automate supply chain operations, inventory
            tracking, order administration, and customer relationship workflows.
         </>
      ),
   },
   {
      question: 'How do you optimize eCommerce websites for SEO and conversions?',
      answer: (
         <>
            <p className="faq-list-title m-0">We implement:</p>
            <ul className="faq-list">
               <li>Mobile-first and lightning-fast website performance</li>
               <li>Schema markup for better search visibility</li>
               <li>AI-powered product recommendations to boost sales</li>
               <li>
                  SEO-friendly URLs, structured data, and metadata optimization
               </li>
            </ul>
         </>
      ),
   },
   {
      question: 'How do I start using custom eCommerce software development?',
      answer: (
         <>
            If you are still figuring things out, we are happy to talk. We will take
            a look at where your store is right now, what it needs, and help build
            something solid that actually fits how you work.
         </>
      ),
   },
];
 
function EcommercePage() {
   useIndustriesNavbarScroll()

   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />
         <EcommerceSectionThree />
         <FiFromStrategy />
         <SeamlessFinTech />
         <EcoWhyChoose />
         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>

         <FAQs faqsConst={FAQS} />

         <ContactUsForm />
      </>
   )
}

export default EcommercePage
